<template>
  <b-modal v-model="model" centered modal-class="modal-bb-squared" hide-footer>
    <template slot="modal-header">
      <h5>Your request was sent!</h5>
      <p class="fs15 text-gray-700 pt-10">
        Thank you for requesting the Scout service. A dedicated Recruitment Success Manager will
        instantly be assigned and will reach out to you to arrange a kickoff call within the next
        few hours.
      </p>
      <button class="close" @click="close"></button>
    </template>
    <template slot="default">
      <b-row class="pt-20 align-items-center">
        <!-- <b-col class="fs20 fw500 pb-20">
          Thank you for requesting the Scout service. A dedicated
          Recruitment Success Manager will instantly be assigned and will reach
          out to you to arrange a kickoff call within the next few hours.
        </b-col> -->
        <b-col class="col-auto">
          <img class="img-fluid" :src="require('~/assets/img/ilustrations/using_post.svg')" />
        </b-col>
      </b-row>

      <button class="btn btn-lg w-100 mt-40" @click="onSignUp">
        Close
      </button>

      <!-- <div class="text-center fs14 py-20">
        Already have an account?
        <button class="btn btn-link" @click="onSignIn">Log in</button>
      </div> -->
    </template>
  </b-modal>
</template>

<script>
// import JobsListItem from '@/components/jobs/JobsListItem'
import shuffle from 'lodash/shuffle';
import slice from 'lodash/slice';

export default {
  components: {
    // JobsListItem
  },
  props: {
    value: {
      required: true,
      type: Boolean
    },
    related: Array
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    randomJobs() {
      return slice(shuffle(this.related), 0, 3);
    }
  },
  methods: {
    onSignUp() {
      this.close();
      this.$store.dispatch('modal/auth', {
        initialRoute: 'signup-landing',
        onCancel() {
          this.$store.dispatch('modal/cancel');
        }
      });
    },
    onSignIn() {
      this.close();
      this.$store.dispatch('modal/auth', {
        initialRoute: 'signin',
        onCancel() {
          this.$store.dispatch('modal/cancel');
        }
      });
    },
    close() {
      this.model = false;
    }
  }
};
</script>
<style scoped lang="scss">
.application-sent {
  &__related__wrapper {
    margin: 0 -3.125rem 0 -3.125rem;
    padding: 0 3.125rem;
    border-top: 1px solid #e8e9ea;
  }
}
</style>
